import React from 'react';
import css from './EventCardSkeleton.module.css';

/**
 * Skeleton placeholder for EventCard with shimmer.
 * Matches EventCard layout (image + title + details lines) for "Events for you" loading state.
 * Shimmer is disabled when user prefers reduced motion.
 */
const EventCardSkeleton = () => {
  return (
    <div className={css.skeletonCard} aria-hidden="true">
      <div className={`${css.sk} ${css.skImage}`} />
      <div className={css.skContent}>
        <div className={`${css.sk} ${css.skLine} ${css.skTitle}`} />
        <div className={`${css.sk} ${css.skLine} ${css.skDetails}`} />
        <div className={`${css.sk} ${css.skLine} ${css.skShort}`} />
      </div>
    </div>
  );
};

export default EventCardSkeleton;
